<div class="w-full flex flex-col justify-center">
    <div class="w-full flex justify-end p-2">
        <a class="h-10 w-10 flex justify-center items-center hover:bg-gray-200 rounded-full cursor-pointer" (click)="closeDrawer()">
                <em class="ti ti-x text-gray-900 text-xl"></em>
        </a>
    </div>
    <div class="p-6 pt-0">
        <img class="mx-auto pb-6" width="250" height="200" src="/assets/gifs/location.gif" alt="" >
        <p class="text-2xl font-semibold text-center relative bottom-2">{{'location.no_history_found' | translate}} {{searchDate | dateformat}}</p>
    
        <p class="text-base text-center font-semibold mt-2">{{'location.choose_different_date' | translate}}</p>
        <input 
                    [matDatepicker]="routeDatePicker"
                    type="text" 
                    name="searchDate"
                    id="searchDate"  
                    [(ngModel)]="searchDate"
                    class="mt-3 mb-2 block w-full rounded-md border border-gray-300 focus:border-indigo-500 bg-white px-3 py-3 leading-none text-base cursor-pointer"
                    [placeholder]="utilityService.getLocaleValue('input.placeholder.pick_date')"
                    (click)="routeDatePicker.open()"
                    value=""
                    (dateChange)="onDateChange()"
                    [datePickerFormat]="dateFormat"
                    [max]="today"
                    readonly
            >     
            <mat-datepicker [dateClass]="dateClass"  #routeDatePicker ></mat-datepicker>
        <p class="text-base text-blue-500 cursor-pointer text-center mt-2" (click)="closeDrawer()" routerLink="/maps">{{'locaton.go_back_to_maps' | translate}}</p>
    </div>
</div>